import { CULTURE_ITEMS } from "@/data/indiaContent";

const toneBar = { saffron: "bg-[var(--saffron)]", green: "bg-[var(--india-green)]", chakra: "bg-[var(--chakra)]" };

export function CultureSection() {
  return (
    <section id="roots" className="relative z-10 scroll-mt-24 py-20" data-testid="roots-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="eyebrow text-[var(--saffron-deep)]">भारत की जड़ें</p>
          <h2 className="mt-3 font-serif text-3xl font-bold tracking-tight text-[var(--chakra-deep)] sm:text-4xl">Root of India</h2>
          <p className="mt-4 text-base text-stone-600 md:text-lg">
            Five thousand years of continuous civilisation, still practised every morning in kitchens, courtyards and concert halls.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {CULTURE_ITEMS.map((item, i) => (
            <article
              key={item.title}
              data-testid={`roots-card-${i}`}
              className={`card-lift group overflow-hidden rounded-2xl border border-[var(--line)] bg-white ${i % 2 === 1 ? "lg:translate-y-8" : ""}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden">
                <img src={item.image} alt={item.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-5 text-white">
                  <p className="font-devanagari text-lg leading-none text-[var(--saffron)]">{item.hindi}</p>
                  <h3 className="mt-1 font-serif text-xl font-semibold">{item.title}</h3>
                </div>
              </div>
              <div className={`h-1 ${toneBar[item.tone]}`} />
              <p className="p-5 text-sm leading-relaxed text-stone-600">{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
